import React, {useRef, useState, useEffect} from 'react';
import Link from '@/links';
import Script from 'next/script';
import {FLAG, getFeatureValue} from '@/utils/flag-service';
import {useTranslations} from 'next-intl';

const SWORD_LOADING_SCRIPT = process.env.NEXT_PUBLIC_SWORD_LOADING_SCRIPT;

const SwordForm = props => {
  const SCRIPT_STATUSES = {
    PRISTINE: 0,
    LOADED: 1,
    FAILED: 2
  };
  const formRef = useRef();
  const [scriptStatus, setScriptStatus] = useState(SCRIPT_STATUSES.PRISTINE);
  const isNewFtePricingFFEnabled = getFeatureValue(FLAG.NEW_FTE_PRICING, false);

  const t = useTranslations('swordConfig');

  useEffect(() => {
    if (scriptStatus === SCRIPT_STATUSES.LOADED && isNewFtePricingFFEnabled !== null) {
      if (window.swordConfig && formRef.current) {
        window.swordConfig.newFtePricingLabelEnabled = isNewFtePricingFFEnabled;
        window.Sword.create(formRef.current, window.swordConfig);
      }
    }
  }, [scriptStatus, isNewFtePricingFFEnabled]);

  const swordScriptLoaded = () => {
    if (typeof window !== 'undefined' && 'Sword' in window) {
      setScriptStatus(SCRIPT_STATUSES.LOADED);
    }
  };

  const swordScriptErrored = () => {
    setScriptStatus(SCRIPT_STATUSES.FAILED);
    window?.Rollbar?.error('Sword script failed to load.');
  };

  if (scriptStatus === SCRIPT_STATUSES.FAILED) {
    return (
      <div id="signup-form" className="success_registration">
        <p>
          {t.rich('swordScriptError', {
            a: chunks => (
              <Link href="/auth/shield?prompt=signup" variant="arrow" internal>
                {chunks}
              </Link>
            )
          })}
        </p>
      </div>
    );
  }

  return (
    <>
      <Script
        id="sword-script"
        src={SWORD_LOADING_SCRIPT}
        strategy="afterInteractive"
        onReady={swordScriptLoaded}
        onError={swordScriptErrored}
      />
      <div id="signup-form" ref={formRef}>
        <p>{t('swordScriptLoading')}</p>
      </div>
    </>
  );
};

export default SwordForm;
